<template>
  <div class="agreement-record">
    <v-layout row>
      <v-flex xs12>
        <span class="agreement-record-title">
          <a :href="link" target="blank">
            {{title}}
            <v-icon small>link</v-icon>
          </a>
        </span>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 class="agreement-record-meta">
        <span class="agreement-record-status">
          <v-chip :color="displayStatusChipColor" :text-color="displayStatusChipTextColor" small>
            {{displayStatus}}
          </v-chip>
        </span>
        <span class="agreement-record-date">{{displayDate}}</span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Moment from 'moment';

export default {
  props: {
    link: {
      type: String,
      required: true,
    },
    signedDate: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    displayDate() {
      return this.signedDate
        ? Moment(this.signedDate).format('MM.DD.YYYY')
        : '';
    },
    displayStatus() {
      switch (this.status.toLowerCase()) {
        case 'signed':
          return 'Agreed';
        case 'declined':
          return 'Declined';
        default:
          return 'Unsigned';
      }
    },
    displayStatusChipColor() {
      switch (this.displayStatus) {
        case 'Agreed':
          return 'green';
        case 'Declined':
          return 'red';
        default:
          return '';
      }
    },
    displayStatusChipTextColor() {
      switch (this.displayStatus) {
        case 'Agreed':
        case 'Declined':
          return 'white';
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/typography';

.agreement-record {
  padding: 10px 0;

  &-date {
    font-size: 0.9rem;
    font-style: italic;
  }

  &-meta {
    > span {
      vertical-align: middle;
    }
  }

  &-title {
    font-weight: $typography-weight-bold;
  }
}
</style>
